//#region imports

import { Box, FormControl, Button, Grid, MenuItem, TextField, Typography, Autocomplete, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { cfpBaseUrl } from '../../../network/urls';
// import "../MeterChangeRequest/MeterChangeRequestForm.scss";
import "../../GeneralServices/NewConnection/NewConnectionForm.scss";
import { CircularProgress, Backdrop } from '@mui/material';
import { portalName } from '../../../utils/PortalName';
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import mepcologo from "../../../images/mepcoLogo.png";
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';

import { addBusinessDays, calculateRemainingBusinessDays, companyShortName, dBillAPI, getMeterType, getPermissions, getPhase, getRelevantCFCCode, numberFormatting, subDivAPI, subdivisionName } from '../../../services/Functions';
import Error from '../../../components/error/error';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DoneIcon from '@mui/icons-material/Done';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import StepProgressBar from '../../../components/StepProgressBarForm/StepProgressBar';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import SUNDARLOGO from "../../../images/discologos/sundar-logo.png";

import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../../images/pitc.png';
import CheckPermissions from '../../../authorization/authorization';
//#endregion

const DueDateExtensionForm = () => {
  //#region initial values
  const initialValues = {
    // Classification group Initial Values
    iv_consumer_id: '',
    iv_reference_number: '',
    iv_circle: '',
    iv_division: '',
    iv_sub_divison: '',
    iv_address: '',
    // Payment plan field
    iv_payment_plan: 1,
    // Applicant Details group Initial Values
    iv_applicant_name: '',
    iv_father_name: '',
    iv_applicant_cnic: '',
    iv_applicant_phone_no: '',
    iv_applicant_email: '',
    // Required Documents Initial Values
    iv_applicant_cnic_document: null,
    iv_last_paid_bill: null,
    iv_connection_type: '',
    iv_tariff_description: '',
    iv_tariff_code: '',
    iv_meter_type: '',
    iv_phase: ''
  }
  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );
  //#endregion

  //#region states
  // Classification Group States
  const [referenceNumber, setReferenceNumber] = useState('');
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [dueDate, setDuedate] = useState('')
  const [address, setAddress] = useState('');
  const [connectionType, setConnectionType] = useState('');
  const [billAmount, setBillAmount] = useState('')
  const [extendedDate, setExtendedDate] = useState('');
  const [maxExtendableDueDate, setMaxExtendableDueDate] = useState('');

  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [applicationId, setApplicationId] = useState();
  // States for hiding conditional fields
  const [hierarchyList, setHierarchyList] = useState([]);
  const [noOfDaysToExtend, setNoOfDaysToExtend] = useState(1);
  const navigate = useNavigate()
  const [error, setError] = useState();
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [dueDateExtensionPopUp, setDueDateExtensionPopUp] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const [billMonth, setBillMonth] = useState(null);
  const [tariff, setTariff] = useState(null);
  const [tariffDesc, setTariffDesc] = useState(null);
  const [ccCode, setCcCode] = useState(null)
  const [availableDays, setAvailableDays] = useState([]);
  const [ddeProvisions, setDdeProvisions] = useState();
  const [searchBy, setSearchBy] = useState('referenceNo');
  const [netBill, setNetBill] = useState('');
  const [payment13, setPayment13] = useState('');
  const [gbHistAss13, setGbHistAss13] = useState('');

  //#endregion
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const getLogo = (code) => {
    switch (code) {
      case '10':
        return pitcLogo
      case '11':
        return LESCOLOGO
      case '12':
        return GEPCOLOGO
      case '13':
        return FESCOLOGO
      case '14':
        return IESCOLOGO
      case '15':
        return MEPCOLOGO
      case '26':
        return PESCOLOGO
      case '27':
        return HAZECOLOGO
      case '37':
        return HESCOLOGO
      case '38':
        return SEPCOLOGO
      case '48':
        return QESCOLOGO
      case '59':
        return TESCOLOGO
      case '91':
        return SUNDARLOGO
      default:
        return MEPCOLOGO
    }
  }
  //#region local storage
  const { token, code: userCode, userId, cfcLevelId, csc, permissions, currentDateTime } = useSelector((state) => state.auth);
  let subDivList = JSON.parse(window.localStorage.getItem("subDivisions"));
  let userCompany = userCode.slice(0, 2);
  //#endregion

  //#region formik
  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm } =
    useFormik({
      initialValues,
      validationSchema: Yup.object().shape({
        // Classification group Validations
        iv_reference_number: Yup.string().when('iv_search_by', {
          is: () => searchBy === 'referenceNo',
          then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
          otherwise: Yup.string().optional()
        }),
        iv_consumer_id: Yup.string().when('iv_search_by', {
          is: () => searchBy === 'consumerId',
          then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
          otherwise: Yup.string().optional()
        }),
        iv_circle: Yup.mixed().required("Please select a circle."),
        iv_division: Yup.mixed().required("Please select a division."),
        iv_sub_divison: Yup.mixed().required("Please select a sub division."),

        // Applicant Details group Validations
        // iv_applicant_name: Yup.string().min(3, "Name should be atleast 3 characters.").max(30, "Name should be less than 30 characters.").required("Please enter applicant name."),
        // iv_applicant_cnic: Yup.string().min(13, "Please enter 13 digit CNIC.").max(13, "Please enter 13 digit CNIC.").required("Please enter valid CNIC number.").matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
        iv_applicant_phone_no: Yup.string().max(11, "Please enter 11 digit phone number.").min(11, "Please enter 11 digit phone number.").required("Please enter valid mobile number.").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
        // iv_applicant_email: Yup.string().email("Enter email as 'john@gmail.com'.").notRequired(),
        // Required Documents Validation

      }),
      onSubmit: async (values, { resetForm }) => {
        const netBillNum = Number(netBill) || 0;
        const payment13Num = Number(payment13) || 0;
        const gbHistAss13Num = Number(gbHistAss13) || 0;

const dDate = new Date(dueDate);
const current = new Date(currentDateTime);

// Normalize both dates to midnight (ignore time)
dDate.setHours(0, 0, 0, 0);
current.setHours(0, 0, 0, 0);



        if (gbHistAss13Num == payment13Num) {
          setError("Bill already paid.");
        }
        else if (netBillNum < 0) {
          setError("Request cannot be entertained.");
        }
        else if (payment13Num >= netBillNum) {
          setError("Bill already paid.");
        } 
        else if (current > dDate) {
          setError('Due date has passed!')
        }

        else {
          setViewBackdrop(true);


          var formdata = new FormData();
          formdata.append("refNo", referenceNumber);
          formdata.append("name", values.iv_applicant_name);
          formdata.append("dueDate", dueDate);
          formdata.append("submittedThrough", portalName);
          formdata.append("isOnline", 1);
          formdata.append("extendedDueDate", extendedDate);
          formdata.append("currentBillAmount", billAmount.replace(/,/g, ""));
          formdata.append("createdBy", userId);
          formdata.append("noOfDays", noOfDaysToExtend)
          formdata.append("subDivisionCode", values.iv_sub_divison);
          formdata.append("divisionCode", values.iv_division);
          formdata.append("circleCode", values.iv_circle);
          formdata.append("companyCode", parseInt(values.iv_circle.toString().slice(0, 2)));
          formdata.append("customerId", customerId);
          formdata.append("billMonth", billMonth);
          formdata.append("tariffCode", tariff);
          formdata.append("tariffDesc", tariffDesc);
          formdata.append("ccCode", ccCode);
          formdata.append("address", address);
          formdata.append("connectionType", connectionType);
          formdata.append("applicantCNIC", values.iv_applicant_cnic);
          formdata.append("applicantPhone", values.iv_applicant_phone_no);
          formdata.append("applicantEmail", values.iv_applicant_email);
          formdata.append("cfcId", csc);
          formdata.append("referedToCFCId", '');
          formdata.append("maxExtendableDueDate", maxExtendableDueDate)
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);;

          var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
          };

          await fetch(cfpBaseUrl + "DateExtention/dueDateExtention", requestOptions)
            .then(response => response.json())
            .then(result => {

              if (result.status === '200') {
                setApplicationId(result.dueDateExtentionRequestId)
                const applicationID = result.dueDateExtentionRequestId
                printApplicationReceipt(values, applicationID, userId, referenceNumber);
                resetForm()
                setDefaultCircle()
                setDefaultDivision()
                setSubDivision()
                setAddress('')
                setConnectionType('')
                setBillAmount('')
                setDuedate('')
                setNoOfDaysToExtend()
                setExtendedDate('')
                setDueDateExtensionPopUp(true)
              }
              else {
                setError(result.message)
              }
            })
            .catch(error =>
              setError(error)
            );
          setViewBackdrop(false);
        }
      }
    })
  //#endregion

  //#region use effects
  let options = [];

  // useEffect(() => {

  //   if (
  //     CheckPermissions(Permissions, 'Billing and Collection', 'Due Date Extension', 'Workflow Permissions', '1 - 3 Days')
  //   ) {
  //     options = [1, 2, 3];
  //   }
  // }, [dueDate]);

  useEffect(() => {
    let startDate = new Date(dueDate);
    let futureDate = addBusinessDays(startDate, noOfDaysToExtend);

    const year = futureDate.getFullYear();
    const month = ('0' + (futureDate.getMonth() + 1)).slice(-2);
    const day = ('0' + futureDate.getDate()).slice(-2);
    const formattedDate = `${year}-${month}-${day}`;
    setExtendedDate(formattedDate ? formattedDate : '-');
  }, [dueDate, noOfDaysToExtend])


  useEffect(() => {
    let startDate = new Date(dueDate);
    let futureDate = addBusinessDays(startDate, 10);

    const year = futureDate.getFullYear();
    const month = ('0' + (futureDate.getMonth() + 1)).slice(-2);
    const day = ('0' + futureDate.getDate()).slice(-2);
    const formattedDate = `${year}-${month}-${day}`;
    setMaxExtendableDueDate(formattedDate ? formattedDate : '-');
  }, [dueDate])


  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(subDivList)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  useEffect(() => {
    if (!hierarchyList || !defaultCircle) return;

    const uniqueDivisions = hierarchyList
      .filter(division => division.circleCode === defaultCircle.code)
      .reduce((uniqueDivisions, division) => {
        const existingDivision = uniqueDivisions.find(d => d.code === division.divisionCode);
        if (!existingDivision) {
          uniqueDivisions.push({
            code: division.divisionCode,
            name: division.divisionName,
          });
        }
        return uniqueDivisions;
      }, []);

    const sortedDivisionArray = uniqueDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setDivisionList(sortedDivisionArray);
  }, [defaultCircle, hierarchyList]);

  useEffect(() => {
    if (!defaultDivision || !hierarchyList) return;

    const uniqueSubDivisions = hierarchyList
      .filter(subDivision => subDivision.divisionCode === defaultDivision.code)
      .reduce((uniqueSubDivisions, subDivision) => {
        const existingSubDivision = uniqueSubDivisions.find(s => s.code === subDivision.subDivisionCode);
        if (!existingSubDivision) {
          uniqueSubDivisions.push({
            code: subDivision.subDivisionCode,
            name: subDivision.subDivisionName,
          });
        }
        return uniqueSubDivisions;
      }, []);

    const sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true }));

    setSubDivisionList(sortedSubDivisionArray);
  }, [defaultDivision, hierarchyList]);


  useEffect(() => {
    if (referenceNumber && referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(item => item.code === parseInt(circleCode));

      if (!circleObject) {
        // Handle circle not found
        console.error(`Circle not found with code: ${circleCode}. Contact Admin!`);
        setError(`Circle not found with code: ${circleCode}`);
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode));

      if (!defDivision) {
        // Handle division not found
        console.error(`Division not found with code: ${divisionCode}`);
        setError(`Division not found with code: ${divisionCode}. Contact Admin!`);
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode));
      if (!subDivisionObject) {
        // Handle subdivision not found
        console.error(`Subdivision not found with code: ${subDivisionCode}`);
        setError(`Subdivision not found with code: ${subDivisionCode}. Contact Admin!`);
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);

  useEffect(() => {
    if (values.iv_consumer_id.length === 10) {
      referenceApi(); // function to fetch current information on behalf of reference number
    }
    else {
      setDefaultCircle('')
      setDefaultDivision('')
      setSubDivision('')
      setAddress('')
      setConnectionType('')
      setError('')
      setGbHistAss13('')
      setPayment13('')
      setNetBill('')
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_reference_number = ''
      values.iv_applicant_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_connection_type = ''
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_tariff_code = ''
      values.iv_tariff_description = ''
      values.iv_father_name = ''
      setReferenceNumber()
      setBillAmount('')
      setDuedate('')
      setNoOfDaysToExtend(1)
      setError('')
      setBillMonth(null)
      setTariff(null)
      setTariffDesc(null)
      setCcCode(null)
      setCustomerId(null)
    }
  }, [values.iv_consumer_id])

  useEffect(() => {
    if (values.iv_reference_number.length === 14) {
      referenceApi(); // function to fetch current information on behalf of reference number
    } else {
      setDefaultCircle('')
      setDefaultDivision('')
      setSubDivision('')
      setAddress('')
      setGbHistAss13('')
      setPayment13('')
      setNetBill('')
      setConnectionType('')
      setError('')
      values.iv_circle = ''
      values.iv_division = ''
      values.iv_sub_divison = ''
      values.iv_consumer_id = ''
      values.iv_applicant_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_connection_type = ''
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_tariff_code = ''
      values.iv_tariff_description = ''
      values.iv_father_name = ''
      values.iv_address = ''
      setReferenceNumber()
      setBillAmount('')
      setDuedate('')
      setNoOfDaysToExtend(1)
      setError('')
      setBillMonth(null)
      setTariff(null)
      setTariffDesc(null)
      setCcCode(null)
      setCustomerId(null)
    }
  }, [values.iv_reference_number])

  useEffect(() => {
    if (dueDate && currentDateTime) {
      const dDate = new Date(dueDate);
      const current = new Date(currentDateTime);
  
      // Normalize both dates to midnight (ignore time)
      dDate.setHours(0, 0, 0, 0);
      current.setHours(0, 0, 0, 0);
  
  
      if (current > dDate) {
        setError('Due date has passed!');
      } else {
        setError(null); // optional: clear error if still valid
      }
    }
  }, [dueDate, currentDateTime]);
  

  useEffect(() => {
    const getProvisions = async () => {
      let provisions = await getPermissions(token, 7);

      setDdeProvisions(provisions)
    }
    getProvisions()
  }, [])
  //#endregion 

  //#region API functions
  // Function to fetch sub division and near by name and address through API 
  const referenceApi = async () => {
    if (searchBy === 'consumerId') {
      if (!values.iv_consumer_id) return;
      setViewBackdrop(true)
      let apiResponse = await dBillAPI(token, values.iv_consumer_id)
      const basicInfo = apiResponse.basicInfo
      const histInfo = apiResponse.histInfo
      if (apiResponse.status || basicInfo) {
        setAddress(basicInfo.consumerAddress1 + basicInfo.consumerAddress2)
        setConnectionType(basicInfo.cons_cat)
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth(); // 0-indexed (0 = January)
        const currentYear = currentDate.getFullYear();
        let billDueDate = basicInfo.billDueDate
        let date = new Date(billDueDate)
        if (date.getFullYear() === currentYear && date.getMonth() === currentMonth - 1) {
          setError('The current month’s bill is being processed. Please try again later.');
        } else {
          setError('');
        }
        let bill = billDueDate.slice(0, 10)
        values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_phase = getPhase(basicInfo.sactionLoad)
        values.iv_meter_type = getMeterType(basicInfo.conn_catg, basicInfo.meterType, basicInfo.phase, apiResponse.metersInfo.length)
        setDuedate(bill)
        setCustomerId(basicInfo.appNo)
        setTariff(basicInfo.tariffCode)
        setTariffDesc(basicInfo.tariffDescription)
        setBillMonth(basicInfo.billMonth)
        setCcCode(basicInfo.cc_code ? basicInfo.cc_code : "1501")
        const netBill = numberFormatting(basicInfo.netBill)
        setBillAmount(netBill)
        setNetBill(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : '0')
      
        setPayment13(histInfo.payment13 ? histInfo.payment13.replace(/,/g, '') : '0')
        setGbHistAss13(histInfo.gbHistAssment13 ? histInfo.gbHistAssment13.replace(/,/g, '') : '0')
      } else if (apiResponse.status == false) {
        setError('No Data Found against this Customer ID.')
        errors.iv_reference_number = 'No Data Found against this Customer ID.'
      } else {
        setError('Customer ID. not found!')
        errors.iv_consumer_id = 'Customer ID. not found!'
      }
      setViewBackdrop(false)
    }
    if (searchBy === 'referenceNo') {
      if (!values.iv_reference_number) return;
      setViewBackdrop(true)
      let apiResponse = await dBillAPI(token, values.iv_reference_number)
      const basicInfo = apiResponse.basicInfo
      const histInfo = apiResponse.histInfo
      if (apiResponse.status ) {
        setError('')
        setAddress(basicInfo.consumerAddress1 + basicInfo.consumerAddress2)
        setConnectionType(basicInfo.cons_cat)
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth(); // 0-indexed (0 = January)
        const currentYear = currentDate.getFullYear();
        let billDueDate = basicInfo.billDueDate
        let date = new Date(billDueDate)
        if (date.getFullYear() === currentYear && date.getMonth() === currentMonth - 1) {
          setError('The current month’s bill is being processed. Please try again later.');
        } else {
          setError('');
        }
        values.iv_address = basicInfo.consumerAddress1 + basicInfo.consumerAddress2
        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        let bill = billDueDate.slice(0, 10)
        values.iv_phase = getPhase(basicInfo.sactionLoad)
        values.iv_meter_type = getMeterType(basicInfo.conn_catg, basicInfo.meterType, basicInfo.phase, apiResponse.metersInfo.length)
        setDuedate(bill)
        setCustomerId(basicInfo.appNo)
        setTariff(basicInfo.tariffCode)
        setTariffDesc(basicInfo.tariffDescription)
        setBillMonth(basicInfo.billMonth)
        setCcCode(basicInfo.cc_code ? basicInfo.cc_code : "1501")
        const netBill = numberFormatting(basicInfo.netBill)
        setBillAmount(netBill)
        setNetBill(basicInfo.netBill ? basicInfo.netBill.replace(/,/g, '') : '0')
      
        setPayment13(histInfo.payment13 ? histInfo.payment13.replace(/,/g, '') : '0')
        setGbHistAss13(histInfo.gbHistAssment13 ? histInfo.gbHistAssment13.replace(/,/g, '') : '0')

      } else if (apiResponse.status == false) {
        setError('No Data Found against this reference No.')
        // errors.iv_reference_number = 'No Data Found against this reference No.'
      }
      else {
        setError('Network Error')
        // errors.iv_reference_number = 'Network Error'
      }
      setViewBackdrop(false)
    }
  };
  //#endregion

  //#region functions

  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle('')
    setDefaultDivision('')
    setSubDivision('')
    setAddress('')
    setConnectionType('')
    setError('')
    setGbHistAss13('')
    setPayment13('')
    setNetBill('')
    resetForm()
    values.iv_connection_type = ''
    values.iv_tariff_code = ''
    values.iv_tariff_description = ''
    values.iv_circle = ''
    values.iv_division = ''
    values.iv_sub_divison = ''
    values.iv_consumer_id = ''
    values.iv_applicant_name = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_meter_type = ''
    values.iv_phase = ''
    values.iv_address = ''
    setReferenceNumber()
    setBillAmount('')
    setDuedate('')
    setNoOfDaysToExtend(1)
    setError('')
    setBillMonth(null)
    setTariff(null)
    setTariffDesc(null)
    setCcCode(null)
    setCustomerId(null)
  };

  const printApplicationReceipt = (values, applicationID, userId, referenceNo) => {
    let DiscoCode = values.iv_sub_divison.toString().slice(0, 2);
    const doc = new jsPDF({ compressPdf: true });
    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;
    const smallLogoCodes = ['12', '13', '11', '16', '26', '27', '48', '59'];
    var pageWidth = doc.internal.pageSize.getWidth();

    const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
    const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
    // Get page width

    // Calculate X position to center the logo
    const logoX = (pageWidth - logoWidth) / 2;
    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(getLogo(DiscoCode), "PNG", logoX, height, logoWidth, logoHeight); // Adjust the position and size of the barcode image

    if (DiscoCode === '91') {
      height = height + 30;
    } else {
      height = height + 20;
    }

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Due Date Extension Request",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(values.iv_circle.toString().slice(0, 2)),
      padding,
      height
    );
    doc.text(
      values.iv_sub_divison.toString() +
      " / " +
      subdivisionName(values.iv_sub_divison, subDivisionsArray),
      // 'Sub Division Name',
      padding + leftMargin,
      height
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    // Get the current date
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNo, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");



    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_name, padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 130;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Issued By: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(userId, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      if (userCompany != '91') {
        doc.addImage(
          getWaterMarkLogo(userCompany),
          "PNG",
          0,
          0,
          doc.internal.pageSize.getWidth(),
          doc.internal.pageSize.getHeight()
        );
      }

    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, '_blank');

  };

  const handleClose = () => {
    setDueDateExtensionPopUp(false);
    navigate('/due-date-extension-table');
  };

  const errorCloses = () => {
    setError('')
    // setFieldSurveyError('')
  }

  const referedToCFCLevelId = (totalBillAmount, noOfDaysToExtend) => {
    if (ddeProvisions) {
      let referedToCFCLevelId = 0;
      let instProvAccToNos = ddeProvisions.filter((item) => item.noOfActions == noOfDaysToExtend)
      let instProvAccToBillAmount = instProvAccToNos.find((item) => (item.amountFrom <= totalBillAmount) && (item.amountTo >= totalBillAmount))
      if (instProvAccToBillAmount.cfcLevelId) {
        referedToCFCLevelId = instProvAccToBillAmount.cfcLevelId
      }

      return referedToCFCLevelId
    }
  }
  // const referedToCFCLevelId = (totalBillAmount, noOfDaysToExtend) => {
  //   if (ddeProvisions) {
  //     let referedToCFCLevelId = 0;
  //     let instProvAccToNos = ddeProvisions.filter(
  //       (item) => item.noOfActions == noOfDaysToExtend
  //     );

  //     let instProvAccToBillAmount = instProvAccToNos.find(
  //       (item) =>
  //         item.amountFrom <= totalBillAmount && item.amountTo >= totalBillAmount
  //     );

  //     if (instProvAccToBillAmount && instProvAccToBillAmount.cfcLevelId) {
  //       referedToCFCLevelId = instProvAccToBillAmount.cfcLevelId;
  //     } else {
  //       console.warn("⚠️ Could not determine cfcLevelId. Check DDE provisions or bill range.");
  //     }

  //     return referedToCFCLevelId;
  //   }
  //   return 0; // fallback return if ddeProvisions is undefined
  // };


  const getFinalCFCLevelId = (initialReferedToCFCId, loggedInUserCFCId) => {
    if (initialReferedToCFCId && loggedInUserCFCId) {
      if (initialReferedToCFCId == loggedInUserCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId > initialReferedToCFCId) {
        return initialReferedToCFCId
      } else if (loggedInUserCFCId < initialReferedToCFCId) {
        return loggedInUserCFCId
      }
    }
  }

  const getOfficeCode = (referedToCFCLevelId, referenceNo) => {
    let officeCode = ''
    if (referedToCFCLevelId == 2) {
      officeCode = referenceNo.slice(2, 4)
    } else if (referedToCFCLevelId == 3) {
      officeCode = referenceNo.slice(2, 5)
    } else if (referedToCFCLevelId == 4) {
      officeCode = referenceNo.slice(2, 6)
    } else if (referedToCFCLevelId == 5) {
      officeCode = referenceNo.slice(2, 7)
    }
    return officeCode
  }

  const getRelevantCFCId = async (totalBill, noOfInst, referenceNo) => {
    // if (!ddeProvisions) return '';

    let referedToCFCId = '';
    let initialLevelId = referedToCFCLevelId(parseInt(totalBill.replace(/,/g, '')), noOfInst);

    if (!initialLevelId) {
      console.warn("⚠️ initialReferedToCFCLevelId not found, fallback to userCode.");
      return userCode;
    }

    if (initialLevelId !== parseInt(cfcLevelId)) {
      let finalLevelId = getFinalCFCLevelId(initialLevelId, parseInt(cfcLevelId));
      let officeCode = getOfficeCode(finalLevelId, referenceNo);
      referedToCFCId = await getRelevantCFCCode(token, officeCode, finalLevelId);
    } else {
      referedToCFCId = userCode;
    }

    return referedToCFCId;
  };


  //#endregion

  const [ddeStatusBarArray, setDdeStatusBarArray] = useState([{
    title1: 'APPLICATION',
    title2: 'DETAIL',
    status: 0
  }]);

  useEffect(() => {
    if ((values.iv_consumer_id || values.iv_reference_number) &&
      values.iv_applicant_phone_no &&
      noOfDaysToExtend >= 1
    ) {
      setDdeStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
    else {
      setDdeStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[0] = {
          ...updatedArray[0],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [values])

  return (
    <>
      <Grid container className='nC'>
        <Box className='nCContainer'>
          <div className="headingBarDiv">
            <h3 className="heading">
              Due Date Extension
            </h3>
            <StepProgressBar array={ddeStatusBarArray} />
          </div>
          <form className='ncform'>
            <Typography variant="h6" className="groupTitle">
              <div className="redCell">
              </div>
              Applicant's Details
            </Typography>
            <CustomerInformationCard
              searchBy={searchBy}
              SearchBy={SearchBy}
              errors={errors}
              values={values}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              defaultCircle={defaultCircle}
              circleList={circleList}
              setDefaultCircle={setDefaultCircle}
              defaultDivision={defaultDivision}
              divisionList={divisionList}
              setDefaultDivision={setDefaultDivision}
              subDivision={subDivision}
              subDivisionList={subDivisionList}
              setSubDivision={setSubDivision}
            />
            <Typography variant="h6" className="groupTitle">
              <div className="cyanCell">
              </div>
              Bill Details
            </Typography>
            <Grid container className='container'>
              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Bill Amount</Typography>
                <TextField
                  type='text'
                  name="iv_bill_amount"
                  autoComplete='off'
                  value={billAmount}
                  disabled
                  className='textInputField1'
                />
              </Grid>
              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Due Date</Typography>
                <TextField
                  type='date'
                  autoComplete='off'
                  value={dueDate}
                  className='textInputField1'
                  disabled
                />
              </Grid>
              {/* <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Extension Requested</Typography>
                <Select
                  value={noOfDaysToExtend}
                  onChange={(e) => setNoOfDaysToExtend(Number(e.target.value))}
                  className="dropdownList"
                >
                  <MenuItem value="">
                    <em>Extended</em>
                  </MenuItem>
                  {Array.from({ length: availableDays }, (_, i) => i + 1).map(day => (
                    <MenuItem key={day} value={day}>{day}</MenuItem>
                  ))}
                </Select>
              </Grid> */}

              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel'>Extension Requested</Typography>
                <Select
                  value={noOfDaysToExtend}
                  onChange={(e) => setNoOfDaysToExtend(Number(e.target.value))}
                  className="dropdownList"
                  displayEmpty
                >
                  {CheckPermissions(
                    permissions,
                    'Billing and Collection',
                    'Due Date Extension',
                    'Workflow Permissions',
                    '3 Days'
                  ) ? (
                    [1, 2, 3].map((day) => (
                      <MenuItem key={day} value={day}>
                        {day}
                      </MenuItem>
                    ))
                  ) : CheckPermissions(
                    permissions,
                    'Billing and Collection',
                    'Due Date Extension',
                    'Workflow Permissions',
                    '5 Days'
                  ) ? (
                    [1, 2, 3, 4, 5].map((day) => (
                      <MenuItem key={day} value={day}>
                        {day}
                      </MenuItem>
                    ))
                  ) :
                    CheckPermissions(
                      permissions,
                      'Billing and Collection',
                      'Due Date Extension',
                      'Workflow Permissions',
                      '8 Days'
                    ) ? (
                      [1, 2, 3, 4, 5, 6, 7, 8].map((day) => (
                        <MenuItem key={day} value={day}>
                          {day}
                        </MenuItem>
                      ))
                    )
                      :
                      CheckPermissions(
                        permissions,
                        'Billing and Collection',
                        'Due Date Extension',
                        'Workflow Permissions',
                        '10 Days'
                      ) && (
                        [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((day) => (
                          <MenuItem key={day} value={day}>
                            {day}
                          </MenuItem>
                        ))
                      )
                  }

                </Select>
              </Grid>


              <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                <Typography className='fieldLabel' >Requested Due Date</Typography>
                <TextField
                  type='date'
                  autoComplete='off'
                  value={extendedDate ? extendedDate : '-'}
                  className='textInputField1'
                  disabled
                />
              </Grid>
            </Grid>
            <Grid container >
              <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                {
                  error &&
                  <Error
                    error={error}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "1%", textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button className={((values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) && values.iv_applicant_phone_no != '' && noOfDaysToExtend) === false ? 'disabled-button' : 'button'}
                variant="contained" component="label" onClick={handleSubmit} disabled={((values.iv_consumer_id.length === 10 || values.iv_reference_number.length === 14) && values.iv_applicant_phone_no != '' && noOfDaysToExtend) === false}>
                Submit
              </Button>
            </Box>
          </form >
        </Box >
      </Grid >

      < Dialog
        open={dueDateExtensionPopUp}
        onClose={handleClose}
        className='dialog'
        fullWidth={true}
        maxWidth={'sm'}
        PaperProps={{ style: { width: '100%', borderRadius: 20 } }}
      >
        <DialogTitle  >
          <Box className="backgroundAttached" >
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle"> Request Submitted</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <p className="applicationSubmit">  Your Due Date Extension request is submitted successfully.</p>
            <p className="trackIdPara"> Your Tracking ID.</p>
            <p className="trackId"> {applicationId}</p>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >
    </>
  );
}

export default DueDateExtensionForm;